// target blank script
var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
    }
}

// Images Slider 
$('.imagesslider').owlCarousel({
    autoplay: false,
    margin: 10,
    loop: true,
    center: false,
    nav: false,
    dots: true,
    items: 3,
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 2
        },
        768: {
            items: 3
        },
        1000: {
            items: 3
        },
        1280: {
            items: 3
        },
        1366: {
            items: 3
        }
    }
})


// Collection Product
$('.Collectionslider').owlCarousel({
    autoplay: false,
    margin: 0,
    loop: true,
    autoWidth: true,
    center: true,
    nav: true,
    navText: ["<img src='https://cdn.shopify.com/s/files/1/0791/3422/8793/files/prev.svg?'>", "<img src='https://cdn.shopify.com/s/files/1/0791/3422/8793/files/next.svg?'>"],
    dots: false,
    items: 1
})

// Remove Hashtag In URL
$('a').on('click', function (e) {
    if ($(this).attr('href') == '#')
        return e.preventDefault();
});


// PDP Images Slider
function setPDPSlider() {
    const pdpslider = document.querySelector('.pdpslider');
    if (!pdpslider) return;

    if ($(window).width() > 989) {
        $('.pdpslider').trigger('destroy.owl.carousel');
        $(".pdpslider").addClass("off");
        $(".owl-dots-off").removeClass("hidden");
    } else {
        $(".pdpslider").owlCarousel({
            margin: 0,
            loop: true,
            center: false,
            nav: false,
            dots: true,
            items: 1,
            autoplay: false,
            animateOut: "slideOutUp",
            animateIn: "slideInUp",
        });
        $(".pdpslider").removeClass("off");
        $(".owl-dots-off").addClass("hidden");
    }
}
setPDPSlider();

$(window).resize(function () {
    setPDPSlider();
});

$(".owl-dots-off > a").on("click", function (e) {
    e.preventDefault();
    const targetId = this.getAttribute("href").substring(1); // Remove the # from the href
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
        // Calculate the target's position relative to the viewport
        const offset =
            targetElement.getBoundingClientRect().top + window.scrollY - 100;

        // Scroll smoothly to the target element
        window.scrollTo({
            top: offset,
            behavior: "smooth",
        });
    }
    let alreadyActive = e.currentTarget.parentElement.querySelector("a.owl-dot.active");
    alreadyActive && alreadyActive.classList.remove("active");
    e.currentTarget.classList.add("active");
});

// activate owl dots off according to visible image
// Function to handle visibility
function handleDivVisibility(entries, observer) {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            // Div is in the viewport
            const targetDiv = entry.target;

            // Calculate the percentage of the div's height that is visible
            const visiblePercentage = entry.intersectionRatio * 100;

            if (visiblePercentage >= 80) {
                // At least 80% of the div is visible, take action here
                const alreadyActiveDot = document.querySelector('.owl-dots-off a.active');
                alreadyActiveDot && alreadyActiveDot.classList.remove('active');
                const newActiveDot = document.querySelector(`.owl-dots-off a[data-media-id="${targetDiv.dataset.mediaId}"]`);
                newActiveDot && newActiveDot.classList.add('active');
            }
        }
    });
}

// Set up the Intersection Observer for multiple divs
const productImages = document.querySelectorAll('.pdpslider .product__media-item');
const productImageOptions = {
    root: null, // Use the viewport as the root
    threshold: 0.8, // 80% visibility threshold
};
const productImageObserver = new IntersectionObserver(handleDivVisibility, productImageOptions);

// Observe each Product Image div
productImages.forEach(productImage => productImageObserver.observe(productImage));



// Sticky header change the color
$(window).scroll(function () {
    if ($(window).scrollTop() >= 10) {
        $('.header-wrapper.color-background-1.gradient').addClass('white');
    }
    else {
        $('.header-wrapper.color-background-1.gradient').removeClass('white');
    }
});

// Collection Related Slider
$(document).ready(function () {
    $('.collectionrelated').owlCarousel({
        autoplay: false,
        margin: 20,
        autoplayTimeout: 7000,
        smartSpeed: 800,
        loop: false,
        rewind: false,
        center: false,
        nav: true,
        dots: false,
        items: 3,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 2
            },
            768: {
                items: 2
            },
            1000: {
                items: 3
            },
            1280: {
                items: 3
            },
            1366: {
                items: 3
            }
        }
    });
});


// debounce from underscore.js
function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this, args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};


// Collection Related Slider
$(document).ready(function () {
    $('.discover').owlCarousel({
        autoplay: false,
        margin: 20,
        autoplayTimeout: 7000,
        smartSpeed: 800,
        loop: false,
        rewind: false,
        center: false,
        nav: true,
        dots: false,
        items: 3,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 2
            },
            768: {
                items: 2
            },
            1000: {
                items: 3
            },
            1280: {
                items: 3
            },
            1366: {
                items: 3
            }
        }
    });
});



// Blog Image Slider
$(document).ready(function () {
    $('.blogimage').owlCarousel({
        autoplay: false,
        margin: 0,
        autoplayTimeout: 7000,
        smartSpeed: 800,
        loop: false,
        rewind: false,
        center: false,
        nav: false,
        dots: true,
        items: 1
    });
});



// Blogd Related Slider
$(document).ready(function () {
    $('.blogdiscover').owlCarousel({
        autoplay: false,
        margin: 20,
        autoplayTimeout: 7000,
        smartSpeed: 800,
        loop: false,
        rewind: false,
        center: false,
        nav: true,
        dots: false,
        items: 3,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 2
            },
            768: {
                items: 2
            },
            1000: {
                items: 3
            },
            1280: {
                items: 3
            },
            1366: {
                items: 3
            }
        }
    });
});


// ABZ VIDEO
function avadaVideo(btn, playpause, sound) {
    if (!btn) return;
    const videoWrapper = btn.closest('.abz-video-section');
    if (!videoWrapper) return;
    const video = videoWrapper.querySelector('video');
    if (!video) return;

    if (playpause) video.paused ? video.play() : video.pause();
    if (sound) video.muted = !video.muted;
    btn.classList.toggle("active");
}


// Our Categories Slider
$(document).ready(function () {
    $('.ourcategories').owlCarousel({
        autoplay: false,
        margin: 0,
        autoWidth: true,
        autoplayTimeout: 5000,
        smartSpeed: 500,
        loop: false,
        rewind: false,
        center: false,
        nav: true,
        dots: false,
        items: 3,
        responsive: {
            0: {
                items: 2
            },
            600: {
                items: 3
            },
            768: {
                items: 4
            },
            1000: {
                items: 5
            },
            1280: {
                items: 5
            },
            1366: {
                items: 3
            }
        }
    });
});


// Desiner Explore
$('.designerexplore').owlCarousel({
    autoplay: true,
    autoplayTimeout: 7000,
    smartSpeed: 800,
    margin: 0,
    loop: true,
    center: false,
    nav: true,
    autoHeight: true,
    dots: false,
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 1
        },
        768: {
            items: 1
        },
        1000: {
            items: 1
        },
        1280: {
            items: 1.1
        },
        1366: {
            items: 1.1
        },
        1536: {
            items: 1.1
        }
    }
})

// Single Banner 
$('.singlebanner').owlCarousel({
    autoplay: true,
    autoplayTimeout: 7000,
    smartSpeed: 800,
    margin: 0,
    loop: true,
    center: false,
    nav: true,
    autoHeight: true,
    dots: false,
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 1
        },
        768: {
            items: 1
        },
        1000: {
            items: 1
        },
        1280: {
            items: 1
        },
        1366: {
            items: 1
        },
        1536: {
            items: 1
        }
    }
})

// Our Partner 
$('.ourpartner').owlCarousel({
    autoplay: true,
    autoWidth: false,
    autoplayTimeout: 5000,
    smartSpeed: 600,
    margin: 0,
    loop: true,
    center: false,
    nav: false,
    dots: false,
    responsive: {
        0: {
            items: 3
        },
        600: {
            items: 3
        },
        768: {
            items: 4
        },
        1000: {
            items: 5
        },
        1280: {
            items: 6
        },
        1366: {
            items: 7
        },
        1536: {
            items: 8
        }
    }
})
